import { useMapContext } from 'widgets/choroplethMap/contexts/mapContext';
import { useEffect } from 'react';
import { useChoroplethContext } from 'widgets/choroplethMap/contexts/choroplethContext';

export default function useChoroplethFillColor({ sourceName, layerName }: { sourceName: string; layerName: string }) {
	const [{ map }] = useMapContext();
	const [{ choroplethColors }] = useChoroplethContext();

	//fill color
	useEffect(() => {
		if (!map) return;
		const source = map.getSource(sourceName);
		if (!source) return;
		const layer = map.getLayer(layerName);
		if (!layer) return;
		try {
			map.setPaintProperty(layerName, 'fill-color', choroplethColors);
		} catch {
			//error
		}
	}, [map, sourceName, layerName, choroplethColors]);
}
